import type { FC } from 'react';
import { Card, Stack, styled, Typography } from '@mui/material';
import { Label } from '@pflegenavi/web-components';

interface BooleanStatusCardProps {
  activeLabel: string;
  activeValue: string;
  inactiveLabel: string;
  inactiveValue: string;
  active: boolean;
}

export const BooleanStatusCard: FC<BooleanStatusCardProps> = ({
  active,
  activeLabel,
  activeValue,
  inactiveLabel,
  inactiveValue,
}) => {
  return (
    <Card>
      <RootContainer>
        <InnerContainer
          direction="row"
          alignItems="center"
          flexWrap="wrap"
          spacing={1}
          gap={1}
        >
          {active ? (
            <>
              <Typography fontWeight={600}>{activeLabel}:</Typography>
              <Label variant="filled" color="success" sx={{ color: 'white' }}>
                {activeValue}
              </Label>
            </>
          ) : (
            <>
              <Typography fontWeight={600}>{inactiveLabel}:</Typography>
              <Label variant="filled" color="error" sx={{ color: 'white' }}>
                {inactiveValue}
              </Label>
            </>
          )}
        </InnerContainer>
      </RootContainer>
    </Card>
  );
};
const RootContainer = styled(Stack)(({ theme }) =>
  theme.unstable_sx({
    p: 1,
    borderRadius: 3,
  })
);

const InnerContainer = styled(Stack)(({ theme }) =>
  theme.unstable_sx({
    bgcolor: 'grey.200',
    paddingX: 2,
    paddingY: 3,
    borderRadius: 3,
  })
);
